const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  routesLists: state => state.user.routesList,
  imageCache: state => state.app.imageCache,
  themeType: state => state.theme.type
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js